import { render, staticRenderFns } from "./orderDetailRefundDetail.vue?vue&type=template&id=05e58159&scoped=true"
import script from "./orderDetailRefundDetail.vue?vue&type=script&lang=js"
export * from "./orderDetailRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetailRefundDetail.vue?vue&type=style&index=0&id=05e58159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e58159",
  null
  
)

export default component.exports